videojs.registerPlugin('thirtythirdPlaylist', function() {
	var player = this;
	console.log(player);
	// console.log(player.playlistMenu);
	
	
	const el = player.el();
	const video = el.querySelector('.vjs-tech');
	const poster = el.querySelector('.vjs-poster');
	const playbutton = el.querySelector('.vjs-big-play-button');
	const controlbar = el.querySelector('.vjs-control-bar');
	const adcontainer = el.querySelector('.vjs-ima3-ad-container');
	
	const wrapper = document.createElement('div');
	wrapper.classList.add('vjs-tech__wrapper');
	
	wrapper.append(video);
	wrapper.append(poster);
	wrapper.append(playbutton);
	wrapper.append(controlbar);
	el.prepend(wrapper);
	
	if ( adcontainer !== null ) {
		wrapper.append(adcontainer);
	}
	
	player.on('loadstart', function() {
		// fill out playlist things
		const titleContainer = el.querySelector('.vjs-title-bar');
		
		if ( titleContainer.querySelector('.vjs-playlist-item__aux') !== null ) {
			titleContainer.querySelector('.vjs-playlist-item__aux').remove();
		}
		
		const titleEl = titleContainer.querySelector('.vjs-title-bar-title');
		titleEl.classList.add('content-card__title');
		
		const descriptionEl = titleContainer.querySelector('.vjs-title-bar-description');
		descriptionEl.classList.add('content-card__excerpt');
		
		const auxContainer = document.createElement('div');
		auxContainer.classList.add('vjs-playlist-item__aux');
		
		
		const metaWrapper = document.createElement('div');
		metaWrapper.classList.add('content-card__date');
		
		
		if ( player.mediainfo.tags ) {
			const tagContainer = document.createElement('p');
			tagContainer.classList.add('content-card__date__tag');
			const tag = document.createElement('span');
			tag.classList.add('category-tag');
			tag.textContent = player.mediainfo.tags[0];
			tagContainer.append(tag);
			metaWrapper.append(tagContainer);
		}
		
		if ( player.mediainfo.createdAt ) {
			const dateEl = document.createElement('p');
			dateEl.classList.add('content-card__date__date');
			const date = new Date( player.mediainfo.createdAt );
			dateEl.textContent = date.toLocaleDateString('en-US', {
				year: '2-digit',
				month: 'numeric',
				day: 'numeric'
			});
			metaWrapper.append(dateEl);
		}
		
		
		titleContainer.prepend(auxContainer);
		
		auxContainer.append(metaWrapper);
	});
	
	const processPlaylistOL = () => {
		const playlistOL = player.playlistMenu.el();
		
		if ( playlistOL.classList.contains('thirtythird') ) {
			return;
		}
		
		playlistOL.classList.add('thirtythird');
		const playlistOLParent = playlistOL.parentNode;
		
		const upNext = document.createElement('p');
		upNext.classList.add('has-nav-font-size');
		upNext.textContent = 'Up Next';
		playlistOLParent.insertBefore(upNext, playlistOL);
		
		
		
		const items = player.playlistMenu.items;
		const processItem = (item) => {
			const itemEl = item.el();
			itemEl.classList.add('content-card');
			itemEl.classList.add('is-style-condensed');
			const picture = itemEl.querySelector('picture');
			picture.classList.add('content-card__image');
			
			
			const titleContainer = itemEl.querySelector('.vjs-playlist-title-container');
			titleContainer.classList.add('content-card__title');
			const durationEl = itemEl.querySelector('.vjs-playlist-duration');
			
			const auxContainer = document.createElement('div');
			auxContainer.classList.add('content-card__content');
			
			
			const metaWrapper = document.createElement('div');
			metaWrapper.classList.add('content-card__date');
			
			const metaWrapperWrapper = document.createElement('div');
			metaWrapperWrapper.classList.add('content-card__date-wrapper');
			
			
			if ( item.item.tags ) {
				const tagContainer = document.createElement('div');
				tagContainer.classList.add('content-card__date__tag');
				const tag = document.createElement('div');
				tag.classList.add('category-tag');
				tag.textContent = item.item.tags[0];
				tagContainer.append(tag);
				metaWrapper.append(tagContainer);
				
			}
			
			metaWrapperWrapper.append(metaWrapper);
			auxContainer.append(metaWrapperWrapper);
			
			auxContainer.append(titleContainer);
			
			if ( item.item.createdAt ) {
				const dateEl = document.createElement('div');
				dateEl.classList.add('content-card__date__date');
				const date = new Date( item.item.createdAt );
				dateEl.textContent = date.toLocaleDateString('en-US', {
					year: '2-digit',
					month: 'numeric',
					day: 'numeric'
				});
				metaWrapper.append(dateEl);
			}
			
			
			itemEl.prepend(auxContainer);
			picture.append(durationEl);
			
			itemEl.addEventListener('click', function(){
				if ( window.innerWidth <= 1110 ) {
					let target = jQuery( el ).offset().top - 180;
					if ( window.innerWidth <= 767 ) {
						target = jQuery( el ).offset().top - 72;
					}
					let dist = Math.abs(jQuery(window).scrollTop() - target);
					
					jQuery([document.documentElement, document.body]).animate({
						scrollTop: target
					}, Math.min(1200, ((dist / 1200) * 1000)));
				}
			})
		};
		
		items.forEach(processItem);
		const playlistOLContainer = playlistOL.closest('.playlist-wrapper');
		
		if ( items.length <= 4 ) {
			playlistOLContainer.classList.add('show-all');
		}
		
		if ( playlistOL.scrollHeight > playlistOL.clientHeight ) {
			playlistOL.classList.add('scrollable');
		}
		
		playlistOL.addEventListener('scroll', function(e){
			if ( playlistOL.scrollTop > 12 ) {
				playlistOL.classList.add('scrolled');
			} else {
				playlistOL.classList.remove('scrolled');
			}
			
			if ( playlistOL.scrollHeight - playlistOL.scrollTop <= playlistOL.clientHeight + 12 ) {
				playlistOL.classList.add('scrolled-bottom');
			} else {
				playlistOL.classList.remove('scrolled-bottom');
			}
		});
		
		window.addEventListener('resize', function() {
			if ( playlistOL.scrollHeight > playlistOL.clientHeight ) {
				playlistOL.classList.add('scrollable');
			} else {
				playlistOL.classList.remove('scrollable');
			}
		});
	};
	
	player.one('loadedmetadata', processPlaylistOL);
});

videojs.registerPlugin('thirtythirdPosterOverrider', function(){
	var player = this;
	console.log();
	
	player.el().querySelector('.vjs-poster img').src = player.el().closest('.content-card').getAttribute('data-thumbnail');
});